/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'

type Props = {
  className: string
  data?: any[]
  loading?: boolean
}

const TablesWidget9C: React.FC<Props> = ({ className, data = [], loading = false }) => {
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>GHG Dashboard</span>
        </h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4' style={{ tableLayout: 'fixed' }}>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-dark'>
                <th style={{ width: '3%' }}>S.N</th>
                <th style={{ width: '8.33%' }}>Date</th>
                <th style={{ width: '8.33%' }}>Product</th>
                <th style={{ width: '12%' }}>Batch id</th>
                <th style={{ width: '8.33%' }}>Quantity</th>
                <th style={{ width: '8.33%' }}>Origin</th>
                <th style={{ width: '8.33%' }}>Site</th>
                <th style={{ width: '12%' }}>Shipped</th>
                <th style={{ width: '8.33%' }}>Recipient</th>
                <th style={{ width: '8.33%' }}>Country</th>
                <th style={{ width: '10%' }}>Feedstock</th>
                <th style={{ width: '7%' }}>GHG Value</th>
                <th style={{ width: '5%' }}>Saving</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={12} className='text-center py-4'>
                    <div className='spinner-border text-primary' role='status'>
                      <span className='visually-hidden'>Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td style={{ wordWrap: 'break-word' }}>{index + 1}</td>
                    <td style={{ wordWrap: 'break-word' }}>
                      {(() => {
                        if (!item.actualSupplyDate) return '-';
                        const date = new Date(item.actualSupplyDate);
                        if (isNaN(date.getTime())) return '-';
                        return date.toISOString().split('T')[0];
                      })()}
                    </td>
                    <td style={{ wordWrap: 'break-word' }}>
                      {item.orderDetails?.[0]?.items?.[0]?.itemName || '-'}
                    </td>
                    <td style={{ wordWrap: 'break-word' }}>
                      {item.id || '-'}
                    </td>
                    <td style={{ wordWrap: 'break-word' }}>
                      {(Number(item.orderDetails?.[0]?.items?.[0]?.quantity) || 0).toFixed(2) || '-'}
                    </td>
                    <td style={{ wordWrap: 'break-word' }}>
                      <img
                        src={item?.kycDocuments?.docUrl}
                        alt="KYC Document"
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          objectFit: 'cover'
                        }}
                      />
                    </td>
                    <td style={{ wordWrap: 'break-word' }}>
                      {item.pickupPointName || '-'}
                    </td>
                    <td style={{ wordWrap: 'break-word' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '4px' }}>
                        {item.transportUsed && <span>
                          {(item.transportUsed || '-').length > 10
                            ? item.transportUsed.substring(0, 10) + '...'
                            : item.transportUsed || '-'
                          }
                        </span>}
                        {item.routeLength && (
                          <span
                            style={{
                              backgroundColor: '#f5f5f5',
                              color: '#666',
                              padding: '2px 8px',
                              borderRadius: '12px',
                              fontSize: '12px',
                              fontWeight: '500'
                            }}
                          >
                            {Number(item.routeLength).toFixed(2)}
                          </span>
                        )}
                      </div>
                    </td>
                    <td style={{ wordWrap: 'break-word' }}>
                      {item.converterName || '-'}
                    </td>
                    <td style={{ wordWrap: 'break-word' }}>
                      {item.converterAddress?.country || '-'}
                    </td>
                    <td style={{ wordWrap: 'break-word' }}>-</td>
                    <td style={{ wordWrap: 'break-word' }}>
                      <div className={`badge badge-light-info fs-7 fw-bold`}>
                        {((item.isccEu?.ghg?.value ?? 0)).toFixed(2)}
                      </div>
                    </td>
                    <td style={{ wordWrap: 'break-word' }}>
                      {(() => {
                        const ghgValue = item?.isccEu?.ghgSaving || 0;

                        // Check if value exists (not null/undefined) rather than > 0
                        if (item?.isccEu?.ghg?.value == null) {
                          return '-';
                        }

                        // Determine colors based on value
                        let textColor2, backgroundColor;
                        if (ghgValue > 1) { // More than 100%
                          textColor2 = 'white';
                          backgroundColor = '#12b886';
                        } else if (ghgValue >= 0.75) { // Between 100% - 75%
                          textColor2 = '#17c653';
                          backgroundColor = '#dfffea';
                        } else { // Less than 75%
                          textColor2 = '#f6c000';
                          backgroundColor = '#fff8dd';
                        }

                        return (
                          <div
                            className={`badge badge-light-info fs-7 fw-bold`}
                            style={{
                              color: textColor2,
                              backgroundColor: backgroundColor
                            }}
                          >
                            {ghgValue.toFixed(2)}%
                          </div>
                        );
                      })()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={12} className='text-center py-4'>No data available</td>
                </tr>
              )}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
  )
}

export { TablesWidget9C }